var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane',{attrs:{"title":"离职申请","showRemarks":false}},[[_vm._v("重新发起离职申请流程")]],2),_c('div',[_c('LeaveAdd',{attrs:{"extra":_vm.extra}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }